export const ICON_SIZES = {
  PARENT: 20,
  CHILD: 18,
  CHEVRON: 16,
  TOGGLE: 24,
} as const;

export const ICON_STROKE_WIDTH = 1.5;

export const ANIMATION_DURATION = {
  COLLAPSE: 300,
  SUBMENU: 300,
} as const;

export const SUBMENU_MAX_HEIGHT = 500; // px
